import { render, staticRenderFns } from "./SystemBatchHistory.vue?vue&type=template&id=1171e528&scoped=true"
import script from "./SystemBatchHistory.vue?vue&type=script&lang=js"
export * from "./SystemBatchHistory.vue?vue&type=script&lang=js"
import style0 from "./SystemBatchHistory.vue?vue&type=style&index=0&id=1171e528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1171e528",
  null
  
)

export default component.exports